import { render, staticRenderFns } from "./TrucksActions.vue?vue&type=template&id=a8933c66"
import script from "./TrucksActions.vue?vue&type=script&lang=js"
export * from "./TrucksActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports